import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './Login';
import SignUp from './SignUp';
import ResetPassword from './ResetPassword';
import OAuthAuthorize from './OAuthAuthorize';
import Logout from './Logout';
import Community from './Community';
import AutoLogin from './AutoLogin';
import LaunchCommunity from './LaunchCommunity';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/oauth/authorize" element={<OAuthAuthorize />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/community" element={<Community />} />
          <Route path="/" element={<Login />} />
          <Route path="/autologin" element={<AutoLogin />} />
          <Route path="/launch-community" element={<LaunchCommunity />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
